import { produce } from 'immer'
import baseReducer from '@utilities/base-reducer'
import * as Actions from './onboarding-action'

const initialState = {
  companyId: '',
}

const onboardingReducer = baseReducer(initialState, {
  [Actions.REQUEST_CREATE_COMPANY_FINISHED](state, action) {
    return produce(state, draftState => {
      draftState.companyId = action.payload
    })
  },
})

export default onboardingReducer
